import { type VotingType } from '../../common/core-api';

export interface FileData {
  id: string;
  name: string;
  hash: string;
  extension: string;
}

export interface IdeaUserAccess {
  userType: number;
}

export interface IdeaUserData {
  id: string;
  displayName: string;
  profileImageFile?: FileData | null;
  userAccess?: IdeaUserAccess | null;
}

export interface IdeaStatusLabel {
  id: string;
  name: string;
  color: string;
  textColor: string;
}

export interface MilestoneConditionData {
  id: string;
  type: string | null;
  target: number | null;
}

export interface MilestoneVotingData {
  type: VotingType | null;
}

export interface MilestoneData {
  id: string;
  name: string | null;
  type: string | null;
  target: number | null;
  isPrivateSubmission: boolean | null;
  condition: MilestoneConditionData | null;
  voting: MilestoneVotingData | null;
}

export interface PhaseData {
  id: string;
  startDate: string | null;
  voting: VotingData | null;
  access: ChallengeAccessData | null;
}

export interface VotingOptionsData {
  maxScore: number | null;
  maxStars: number | null;
}

export interface VotingWalletData {
  isEnabled: boolean | null;
  allowance: number | null;
}

export interface VotingData {
  type: VotingType | null;
  isBlind: boolean | null;
  options: VotingOptionsData | null;
  wallet: VotingWalletData | null;
}

export interface ChallengeAccessOptions {
  showClosedEnabled: boolean;
  voteOnIdeasEnabled: boolean;
}

export interface ChallengeAccessData {
  options: ChallengeAccessOptions;
}

export interface ChallengeData {
  id: string;
  title: string;
  isFunnel: boolean | null;
  isMilestone: boolean | null;
  archived: number | null;
  daysLimit: string | null;
  milestonesResetTime: number | null;
  isPrivateSubmission: boolean | null;
  access: ChallengeAccessData | null;
  voting: VotingData | null;
  milestones: MilestoneData[] | null;
  phases: PhaseData[] | null;
}

export interface IdeaViewerPermissions {
  hasAccess: boolean;
  canModerate: boolean;
  canVoteOnMilestone: boolean;
}

export interface IdeaRow {
  id: string;
  title: string;
  text: string;
  createdAt: string;
  isAnonymous: number;
  moderationStatus: number;
  adoptionStatus: number | null;
  hasReports: number;
  commentCount: number;
  voteCount: number | null;
  score: number | null;
  viewerVoteDirection: number | null;
  viewerPermissions: IdeaViewerPermissions | null;
  viewerWalletAllowance: number | null;
  currentMilestone: string | null;
  lastReachedMilestone: string | null;
  currentPhase: string | null;
  startPhase: string | null;
  endPhase: string | null;
  effectivePhase: PhaseData | null;
  imageFile?: FileData | null;
  user: IdeaUserData;
  statusLabels: IdeaStatusLabel[];
  challenge: ChallengeData | null;
}

export const MODERATION_STATUS = {
  REMOVED: 3,
  DRAFT: 4,
  CLOSED: 5
} as const;

export const MODERATION_LABELS: Record<number, { text: string }> = {
  3: { text: 'Removed' },
  5: { text: 'Closed' }
};
